import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useFetchAgreementStudioData } from '~/components/AgreementStudioPage/hooks/useFetchAgreementStudioData';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
import { useStoreActions, useStoreStatic } from '~/store/store-context';
import { activityLogModalConfig } from '../modals/activityLogModalConfig';
import { withdrawModalConfig } from '../modals/withdrawModalConfig';
import { viewProposalModeOf } from './useProposalViewing.utils';
export function useProposalViewing(param) {
    let { proposalActions, refresh } = param;
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const { getState } = useStoreStatic();
    const fetchAgreementStudioData = useFetchAgreementStudioData();
    const { t: texts } = useLocaleKeys('proposal.dashboard');
    const { t: errorTexts } = useLocaleKeys('errors');
    const [viewProposalMode, setViewProposalMode] = useState(null);
    const openWithdrawModal = (param)=>{
        let { relationshipId, draftId } = param;
        return overlayContext.showModal(withdrawModalConfig({
            relationshipId,
            draftId,
            onSuccess: refresh,
            openedBy: 'agreement-studio'
        }));
    };
    const hasUserContext = ()=>selectors.user.business(getState()) != null && selectors.user.email(getState()) != null;
    const fetchProposal = async (id)=>{
        const loader = 'viewProposal';
        overlayContext.startLoader(loader);
        const result = await handlePromise(Promise.all([
            api.relationship.get(id),
            fetchAgreementStudioData()
        ]));
        overlayContext.stopLoader(loader);
        if (result.success) return result.data[0];
        overlayContext.showErrorToast(errorTexts.unexpected());
        return undefined;
    };
    return {
        viewProposalMode,
        closeViewProposal: ()=>setViewProposalMode(null),
        viewActivityLog: (proposal)=>{
            overlayContext.showModal(activityLogModalConfig({
                relationshipId: proposal.id
            }));
        },
        viewProposal: async (proposal)=>{
            if (!hasUserContext()) return;
            const relationship = await fetchProposal(proposal.id);
            if (relationship == null) return;
            setViewProposalMode(viewProposalModeOf({
                relationship,
                proposal,
                proposalActions,
                texts,
                onWithdraw: openWithdrawModal
            }));
        }
    };
}
